import { useAllSubscriptions } from '../../../../../hooks/fetchers/useAllSubscriptions/useAllSubscriptions';
import DashboardLayout from '../../../../commons/DashboardLayout/DashboardLayout';
import Loading from '../../../../commons/Loading/Loading';
import moment from 'moment';
import Button from '../../../../designSystem/Button/Button';
import { ButtonColor } from '../../../../designSystem/Button/Button.types';
import { useState } from 'react';
import EditSubscriptionsModal from './EditSubscriptionsModal/EditSubscriptionsModal';
import { useCompanyNAF } from '../../../../../hooks/fetchers/useCompanyNAF/useCompanyNAF';

export default () => {

  const { data: subscription, isLoading } = useAllSubscriptions();

  const { data: companyNAF } = useCompanyNAF();

  const [isModalOpen, setModalOpen] = useState(false)

  if (isLoading) return <Loading />;

  return (
    <DashboardLayout>
      {subscription?.map(({ receipt }, index) => (
        <div key={index} className="dashboard-subscriptions__box">
          <div className="dashboard-subscriptions__box-row">
            <div className="dashboard-subscriptions__box-item">
              <span className="dashboard-subscriptions__box-item-title">Plan</span>
              <span>{receipt.plan_name}</span>
            </div>
            <div className="dashboard-subscriptions__box-item">
              <span className="dashboard-subscriptions__box-item-title">Valide jusqu'au</span>
              <span>{moment(receipt.valid_until).format('DD/MM/YYYY')}</span>
            </div>
          </div>
          <div className="dashboard-subscriptions__box-row">
            <div className="dashboard-subscriptions__box-item">
              <span className="dashboard-subscriptions__box-item-title">Mes domaines</span>
              <ul>
                {/* {domains.map((domain, domainIndex) => (
                  <li key={domainIndex}>{domain}</li>
                ))} */}
                {companyNAF?.domains.map(([,domain], domainIndex) => (
                  <li key={domainIndex}>{domain}</li>
                ))}
              </ul>
            <Button
              color={ButtonColor.Secondary}
              style={{ 
                width: 'fit-content',
                marginTop: 'var(--spacing-sToM)'
               }}
               onClick={() => setModalOpen(true)}
            >
              Modifier mes domaines
            </Button>
            </div>
          </div>
        </div>
      ))}
      <EditSubscriptionsModal 
        isOpen={isModalOpen}
        setOpen={setModalOpen}
        domains={companyNAF?.domains}
      />
    </DashboardLayout>
  );
};
